import { convert, getWeight, getRatio, checkFlour, csvToJson } from '@/utils/helpers'
import { WeightOptions, AmountOptions } from '@/utils/constants'

import recipe from '../../../data/recipe'

const _ = require('lodash')

const state = {
  ingredients: []
}

const getters = {
  sortedIngredients: state => {
    return _.sortBy(state.ingredients, i => (checkFlour(i.name) ? 0 : 1))
  },
  flourWeightInGrams(state, getters) {
    return _.sumBy(getters.mainIngredients, ingredient => {
      if (ingredient.weight.measurement === WeightOptions.OUNCES) {
        return +convert.ounces.toGrams(ingredient.weight.value)
      }
      return +ingredient.weight.value
    })
  },
  mainIngredients(state) {
    return _.filter(state.ingredients, i => checkFlour(i.name))
  },
  totalHydration(state) {
    return _.sumBy(state.ingredients, i => +i.ratio * (+i.hydration / 100))
  }
}

const actions = {
  getAllIngredients({ commit }) {
    if (localStorage.getItem('ingredients')) {
      commit('setIngredients', JSON.parse(localStorage.getItem('ingredients')))
    } else {
      recipe.getIngredients(ingredients => {
        commit('setIngredients', ingredients)
      })
    }
  },
  addIngredient(context, payload) {
    let ingredient = {
      name: payload.name,
      hydration: payload.hydration || 0
    }
    if (payload.amount.type === AmountOptions.WEIGHT) {
      ingredient.weight = {
        value: payload.amount.value,
        measurement: payload.amount.measurement
      }
      // converting Everything to Grams to perform calculations
      // This may be overkill, but for now it keeps values consistant
      let weightInGrams =
        payload.amount.measurement === WeightOptions.GRAMS
          ? payload.amount.value
          : convert.ounces.toGrams(payload.amount.value)
      ingredient.ratio = getRatio(weightInGrams, context.getters.flourWeightInGrams)
    } else {
      ingredient.ratio = payload.amount.value
      ingredient.weight = {
        value: getWeight(payload.amount.value, context.getters.flourWeightInGrams),
        measurement: WeightOptions.GRAMS
      }
    }

    context.commit('addIngredient', ingredient)
  },
  addMainIngredient(context, main) {
    let ingredient = {
      name: main.name,
      hydration: main.hydration || 0,
      weight: {
        value: main.amount.value,
        measurement: main.amount.measurement
      },
      ratio: 100
    }
    context.dispatch('addIngredientAsync', ingredient).then(() => {
      const { mainIngredients } = context.getters
      const totalWeightGrams = _.sumBy(mainIngredients, i => {
        return i.weight.measurement === WeightOptions.GRAMS
          ? +i.weight.value
          : +convert.ounces.toGrams(i.weight.value)
      })
      context.commit('resyncFlour', totalWeightGrams)
      context.commit('updateRatios', totalWeightGrams)
    })
  },
  addIngredientAsync({ commit }, ingredient) {
    return new Promise(res => {
      commit('addIngredient', ingredient)
      res()
    })
  },
  updateWeights({ commit, getters }) {
    commit('updateWeights', getters.flourWeightInGrams)
  },
  updateRatios({ commit, getters }) {
    commit('updateRatios', getters.flourWeightInGrams)
  },
  removeIngredient({ commit, getters }, ingredient) {
    commit('removeIngredient', ingredient)
    commit('resyncFlour', getters.flourWeightInGrams)
    commit('updateRatios', getters.flourWeightInGrams)
  }
}

const mutations = {
  addIngredient(state, ingredient) {
    state.ingredients.push(ingredient)
  },
  setIngredients(state, ingredients) {
    state.ingredients = ingredients
  },
  updateIngredients: (state, ingredientData) => {
    const ingredient = {
      name: ingredientData.name
    }
    switch (ingredientData.dataType) {
      case 1:
        ingredient.weight = getWeight(ingredientData.data, ingredientData.flourWeight)
        ingredient.ratio = ingredientData.data
        break
      case 2:
        ingredient.ratio = getRatio(ingredientData.data, ingredientData.flourWeight)
        ingredient.weight = ingredientData.data
        break
    }

    state.ingredients.push(ingredient)
  },
  updateWeights: (state, flourWeight) => {
    _.forEach(state.ingredients, i => {
      if (!checkFlour(i.name)) {
        const newWeight = getWeight(i.ratio, flourWeight)
        i.weight.value =
          i.weight.measurement === WeightOptions.GRAMS
            ? newWeight
            : convert.grams.toOunces(newWeight)
      }
    })
  },
  updateRatios: (state, flourWeight) => {
    _.forEach(state.ingredients, i => {
      if (!checkFlour(i.name)) {
        let weightInGrams =
          i.weight.measurement === WeightOptions.GRAMS
            ? i.weight.value
            : convert.ounces.toGrams(i.weight.value)
        i.ratio = getRatio(weightInGrams, flourWeight)
      }
    })
  },
  removeIngredient: (state, ingredient) => {
    state.ingredients = state.ingredients.filter(i => i.name !== ingredient.name)
  },
  resyncFlour: (state, flourWeight) => {
    state.ingredients = _.map(state.ingredients, i => {
      if (checkFlour(i.name)) {
        const weightInGrams =
          i.weight.measurement === WeightOptions.GRAMS
            ? i.weight.value
            : convert.ounces.toGrams(i.weight.value)
        i.ratio = getRatio(weightInGrams, flourWeight)
      }
      return i
    })
  },
  updateIngredient({ ingredients }, data) {
    const ingredient = _.find(ingredients, data.key)
    if (ingredient) {
      data.update(ingredient)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
